module.exports = __webpack_public_path__ + "img/二维码.b472acd4.png";